import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=627b4df8&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"
import style0 from "./editor.vue?vue&type=style&index=0&id=627b4df8&prod&scoped=true&lang=scss"
import style1 from "./editor.vue?vue&type=style&index=1&id=627b4df8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627b4df8",
  null
  
)

export default component.exports